// @generated by protoc-gen-connect-es v1.6.1 with parameter "target=ts"
// @generated from file announcement/announcement.proto (package vsmr.announcement.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { AnnouncementResponse, CreateAnnouncementRequest, DeleteAnnouncementRequest, DeleteAnnouncementResponse, GetAnnouncementRequest, ListAnnouncementsRequest, ListAnnouncementsResponse, MarkAnnouncementsReadRequest, MarkAnnouncementsReadResponse, UpdateAnnouncementRequest } from "./announcement_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service vsmr.announcement.v1.AnnouncementService
 */
export const AnnouncementService = {
  typeName: "vsmr.announcement.v1.AnnouncementService",
  methods: {
    /**
     * 목록 — 로그인 사용자 누구나(게시된 것). admin 은 초안도 함께 본다.
     * 읽음 상태(마지막 읽은 번호·안 읽은 수)를 같이 싣는다.
     *
     * @generated from rpc vsmr.announcement.v1.AnnouncementService.ListAnnouncements
     */
    listAnnouncements: {
      name: "ListAnnouncements",
      I: ListAnnouncementsRequest,
      O: ListAnnouncementsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * 상세 — 게시된 것은 누구나, 초안은 admin.
     *
     * @generated from rpc vsmr.announcement.v1.AnnouncementService.GetAnnouncement
     */
    getAnnouncement: {
      name: "GetAnnouncement",
      I: GetAnnouncementRequest,
      O: AnnouncementResponse,
      kind: MethodKind.Unary,
    },
    /**
     * 작성 — admin 전용.
     *
     * @generated from rpc vsmr.announcement.v1.AnnouncementService.CreateAnnouncement
     */
    createAnnouncement: {
      name: "CreateAnnouncement",
      I: CreateAnnouncementRequest,
      O: AnnouncementResponse,
      kind: MethodKind.Unary,
    },
    /**
     * 수정 — admin 전용, **아직 알리지 않은 초안만**. 게시된 공지(번호가 있는
     * 것)는 거절한다(FAILED_PRECONDITION). 초안을 게시하는 것은 허용 — 그게
     * 알리는 행위다. 한 번 알린 뒤에는 내리는 것도 안 된다.
     *
     * @generated from rpc vsmr.announcement.v1.AnnouncementService.UpdateAnnouncement
     */
    updateAnnouncement: {
      name: "UpdateAnnouncement",
      I: UpdateAnnouncementRequest,
      O: AnnouncementResponse,
      kind: MethodKind.Unary,
    },
    /**
     * 삭제 — admin 전용, **초안만**. 알린 공지를 지우면 읽은 사람이 나중에
     * 확인할 수도 없다. 잘못 알렸으면 정정 공지를 새로 쓴다.
     *
     * @generated from rpc vsmr.announcement.v1.AnnouncementService.DeleteAnnouncement
     */
    deleteAnnouncement: {
      name: "DeleteAnnouncement",
      I: DeleteAnnouncementRequest,
      O: DeleteAnnouncementResponse,
      kind: MethodKind.Unary,
    },
    /**
     * 읽음 표시 — 사용자별 "마지막으로 읽은 번호". 브라우저가 아니라 서버에
     * 두는 이유는 다른 PC·브라우저에서 같은 공지가 또 뜨지 않게 하기 위해서다.
     *
     * @generated from rpc vsmr.announcement.v1.AnnouncementService.MarkAnnouncementsRead
     */
    markAnnouncementsRead: {
      name: "MarkAnnouncementsRead",
      I: MarkAnnouncementsReadRequest,
      O: MarkAnnouncementsReadResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

